//供应商工作平台模块接口列表

import { base, baseGateway } from "./base"; // 导入接口域名列表
import axios from "@/utils/http"; // 导入http中创建的axios实例

const supplier = {
  // 我的合同
  // 原料供应商工作台合同列表
  postSupplierCtm(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/supplierContractTest/pageSupplierCtm?page=${
        params.page
      }&size=${params.size}`,
      params.tSupplierContractDto
    );
  },
  // 供应商平台根据状态查合同数
  postEvaluate(corporateCode) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/supplierContractTest/pageSupplierCount?corporateCode=${corporateCode}&flag=1`
    );
  },
  // 原料供应商工作台合同详情
  postSupplierContractDetail(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/supplierContractTest/selectSupplierContractDetail/${params}`
    );
  },

  // 银行信息列表
  bankList(params) {
    // return axios.post(`${base()}/srm-web/resume/bankList`, params);
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-business/ks-company-baseinfo/query-company-bank`,
      params
    );
  },
  // 银行信息列表 )(未登录）
  bankListNoLogin(params) {
    return axios.post(`${base()}/srm-web/resume/bankListNoLogin`, params);
  },
  // 银行信息列表详情
  bankListEdit(params) {
    return axios.get(`${base()}/srm-web/resume/getBankInfo/${params}`);
  },
  // 删除银行信息
  bankDelModel(params) {
    return axios.post(
      `${base()}/srm-web/resume/delModel?id=${params.id}&modelType=5`
    );
  },
  // 删除银行信息 （无需登录）
  bankDelBankNoLogin(params) {
    return axios.post(
      `${base()}/srm-web/resume/delBankNoLogin?id=${params.id}&companyCode=${
        params.companyCode
      }`
    );
  },
  // 新增银行信息
  bankSaveBankInfo(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-business/ks-company-baseinfo/saveBankInfo`,
      params
    );
  },
  // 新增银行信息-不带token
  bankSaveBankInfoToken(params) {
    return axios.post(`${base()}/srm-web/resume/saveBankInfoNoLogin`, params);
  },

  // 币种列表
  getCurrencyTypeList(params) {
    // return axios.post(`${base()}/srm-web/resume/getCurrencyTypeList`);
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-business/api/getCurrencyTypeList`,
      params
    );
  },
  // 银行类型列表
  postResumeBankTypeList(params) {
    // return axios.post(`${base()}/srm-web/resume/bankTypeList`);
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-business/api/bankTypeList`,
      params
    );
  },
  // 结算单查询
  postSettleManagement(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/supStatement/list`,
      params
    );
  },
  // 结算单详情
  postSettleManagementDet(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/supStatement/detail`,
      params
    );
  },
  //发票列表上传图片
  postFaPiaoPic(params) {
    return axios.post(`${base()}/srm-web/certificate/uploadAttach`, params);
  },
  //发票列表
  postInvoiceList(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/supStatement/invoiceList`,
      params
    );
  },
  // 发票明细搜索
  postInvoiceDetSearch(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/supStatement/instorageList`,
      params
    );
  },
  // 发票保存
  postInvoiceSave(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/supStatement/saveInvoice`,
      params
    );
  },
  // 发票详情查询
  postInvoiceInfo(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/supStatement/invoiceInfo`,
      params
    );
  },
  // 发票提交
  postInvoice(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/supStatement/commitInvoice`,
      params
    );
  },
};
export default supplier;
